export default __webpack_public_path__ + "static/placeholder-9c280632beed249b995153fda89b0c07.svg";